import { Query, Relationship } from "@com.mgmtp.a12.dataservices/dataservices-access";

import {
	TEXTBAUSTEINE_RELATIONSHIP_DOCUMENT,
	TEXTBAUSTEINE_VERFAHREN_DOCUMENT
} from "../../utilities/variables/documentModelName";
import { DocumentReference } from "../../utilities/documentReference";

import { getVirtualVerfahrenDocRef, RuntimeManifestWithTextbaustein } from "./textbausteinDataProviderHelpers";

/**
 * Erledigt die Erstellung eines Wurzelknotens ohne Kinder.
 * @param targetManifest
 * @returns
 */
export function createEmptyRoot(targetManifest: RuntimeManifestWithTextbaustein): Relationship.LinkWithDocument {
	return {
		document: {
			target: {
				root: {
					name: targetManifest.textbausteinData?.name,
					marker: targetManifest.identification.key,
					correlatedFachverfahrenKey: targetManifest.textbausteinData?.marker
				}
			}
		},
		linkRef: {
			id: getVirtualVerfahrenDocRef(targetManifest),
			linkDescriptor: {
				relationshipModel: TEXTBAUSTEINE_RELATIONSHIP_DOCUMENT,
				entities: [
					{
						role: "parent",
						modelName: TEXTBAUSTEINE_VERFAHREN_DOCUMENT,
						docRef: getVirtualVerfahrenDocRef(targetManifest)
					}
				]
			}
		}
	};
}

/**
 * Erzeugt einen Wurzelknoten (Verfahren_D) mit dem angegebenen Kind.
 * @param targetManifest die Daten des "Textbausteins" aus dem Manifest
 * @param child das Kind zu verbinden mit
 * @param useChildDocument Entscheidet, ob das Dokument aus dem Kind oder der Wurzel verwendet werden soll. Das Child-Dokument sollte verwendet werden, wenn eine query source angegeben wird.
 * @param allManifests eine Liste aller "Textbaustein"-Daten, aus denen die docRef des Elternteils berechnet wird
 * @returns
 */
export function createRootLinkWithChild(
	targetManifest: RuntimeManifestWithTextbaustein,
	child: Query.DocumentTreeResult,
	useChildDocument: boolean
): Relationship.LinkWithDocument {
	return {
		document: useChildDocument
			? { target: child.document }
			: {
					target: {
						root: {
							name: targetManifest.textbausteinData?.name,
							marker: targetManifest.identification.key,
							correlatedFachverfahrenKey: targetManifest.identification.key
						}
					}
				},
		linkRef: {
			id: child.docRef,
			linkDescriptor: {
				relationshipModel: TEXTBAUSTEINE_RELATIONSHIP_DOCUMENT,
				position: Relationship.LinkPosition.TOP,
				entities: [
					{
						role: "child",
						modelName: DocumentReference.fromString(child.docRef).model,
						docRef: child.docRef
					},
					{
						role: "parent",
						modelName: TEXTBAUSTEINE_VERFAHREN_DOCUMENT,
						docRef: getVirtualVerfahrenDocRef(targetManifest)
					}
				]
			}
		}
	};
}

/**
 * Erzeugt eine Verknüpfung mit einem virtuell angelegten "Textbaustein"-Wurzelknoten.
 * @param parent
 * @param child
 * @returns
 */
export function createLinkWithVirtualRoot(
	parent: { docRef: string; model: string },
	child: Query.DocumentTreeResult
): Relationship.LinkWithDocument {
	const childDocRef = DocumentReference.fromString(child.docRef);

	return {
		linkRef: {
			linkDescriptor: {
				relationshipModel: TEXTBAUSTEINE_RELATIONSHIP_DOCUMENT,
				entities: [
					{
						role: "parent",
						modelName: parent.model,
						docRef: parent.docRef
					},
					{
						role: "child",
						modelName: childDocRef.model,
						docRef: child.docRef
					}
				],
				predecessorLinkRef: null,
				position: Relationship.LinkPosition.TOP
			},
			id: child.docRef
		},
		document: {
			target: child.document
		}
	};
}
